import BSWholeWheatPitaBreadProduct from 'models/BSWholeWheatPitaBreadProduct'

export const packagingInitialState = {
  category: BSWholeWheatPitaBreadProduct.category,
  subCategory: BSWholeWheatPitaBreadProduct.subCategory,
  Size: BSWholeWheatPitaBreadProduct.Size,
}
